<template>
	<button :type="type" class="button-light continue-button btn-ripple-effect" :class="size" :disabled="disabled" @click="$emit('click')">
		{{ buttonText }}
	</button>
</template>

<script>
export default {
	name: 'ContinueButton',
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		buttonText: {
			type: String,
			default: 'Continue'
		},
		type: {
			type: String,
			default: 'button'
		},
		size: {
			type: String,
			default: ''
		}
	}
}
</script>

<style lang="scss">
	.continue-button {
		font-family: 'Rubik';
		font-weight: 500;
		background-color: #009BC9;
		color: #FFFFFF;
		width: 290px;
		padding: 16px 20px;
		border-radius: 25px;
		text-transform: uppercase;
		letter-spacing: .13em;
		transition: all .2s ease;
		&.large {
			padding: 21px 20px;
			border-radius: 32px;
		}

		&:disabled {
			background-color: #C8CED9;
			color: #FFFFFF;
			opacity: 1;
		}

		&:hover {
			background-color: lighten(#009BC9, 5);;
		}

		@include respond-below(phone) {
			width: 85%;
		}
	}
</style>
